






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import langSwitch from "../layout/components/lang-switch.vue";
const user = namespace("user");
const app = namespace("app");
const dashboard = namespace("dashboard");
@Component({
  components: { langSwitch }
})
export default class TopHeader extends Vue {
  @user.State userData;
  @user.Action loginOut;
  @user.State selectedOrgCode;
  @user.Action setCurrentStore;
  @dashboard.Action getUnreadNoticeCount;
  @dashboard.State unreadNoticeCount;
  @app.State orderPushState;
  @app.Mutation setOrderPushState;
  @app.State isTmall;
  @app.State appType;
  nameIsExpand: boolean = false;
  orgCode: string = "";
  logOut() {
    this.loginOut();
  }
  created() {
    this.orgCode = this.selectedOrgCode;
    this.getUnreadNoticeCount();
  }
  get name() {
    return this.userData.firstName;
    // (this.userData.firstName ? this.userData.firstName : "") +
    // (this.userData.lastName ? this.userData.lastName : "")
  }
  get role() {
    return this.userData.roleList ? this.userData.roleList.map(item => item.roleName).join() : "-";
  }
  handleGuideLink(command) {
    let url = "";
    switch (command) {
      case "1":
        url = "https://www.yuque.com/mendiantong/zgxl4w/zp4sz3";
        break;
      case "2":
        url = "https://www.yuque.com/mendiantong/zgxl4w/tluglh";
        break;
      case "3":
        url = "https://www.yuque.com/mendiantong/zgxl4w/nw1wo5";
        break;
      case "4":
        url = "https://www.yuque.com/mendiantong/zgxl4w/suxag8";
        break;
      case "5":
        url = "https://www.yuque.com/mendiantong/bncq0g/xwzuoc";
        break;
      case "6":
        url = "https://www.yuque.com/mendiantong/wgy3pl/zg0fs8";
        break;
      case "7":
        url = "https://www.yuque.com/mendiantong/zbvb31/gs36ky";
        break;
      case "8":
        url = "https://www.yuque.com/mendiantong/mfb1t2/mlqc3y";
        break;
      case "9":
        url = "https://www.yuque.com/mendiantong/lt2c5r/kprnxx";
        break;
    }
    window.open(url);
  }
  async handleStoreChange(val) {
    await this.setCurrentStore({
      orgCode: val
    });
    this.$router.push(`/index?storeId=${val}`);
  }
  handleLinkNoticePage() {
    this.$router.push("/notice");
  }
}
